import {httpIncidentAPI} from 'features/http/api/httpIncidentAPI';
import {useSearchHandler} from 'shared/lib/hooks/useSearchParamsHandler';

export const useHttpIncidentHeader = () => {
    const {currentValue, onSearchSubmit} = useSearchHandler('monitor.url');
    const {data, isLoading, error, refetch} = httpIncidentAPI.useGetSummaryHttpIncidentQuery();

    return {
        search: currentValue,
        onSearchSubmit,
        summary: data,
        isSummaryLoading: isLoading,
        isSummaryError: !!error,
        refetchSummary: refetch,
    };
};

export default useHttpIncidentHeader;
